import ApiService from '../api.service';

const permissionsService = {
    getPermissions: async () => {
        try {
            let response = await ApiService.get('permissions');
            return response.data;
        } catch (error) {
            //console.log(error);
        }
    }
};

export default permissionsService;
